export default __webpack_public_path__ + "16a161313054f451b2b50877bde2bb40.png";